/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Text1Answer from 'components/content/shared/questionset/text1/answer/answer';
import Text2Answer from 'components/content/shared/questionset/text2/answer/answer';
import Image1Answer from 'components/content/shared/questionset/image1/answer/answer';
import Image2Answer from 'components/content/shared/questionset/image2/answer/answer';
import EmojiAnswer from 'components/content/shared/questionset/emoji/answer/answer';
import AnswerErrorScreen from 'components/screens/answererror/answererror_container'
import RedeemScreen from 'components/screens/redeem/redeem_container';
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
import { url } from 'utils/urls';
import { makePOSTRequest } from "utils/api/makePOSTRequest";
import { log } from 'utils/logger';
import Timer from 'utils/timer';

// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/shared/answer/answer_styles';
import { createStyles } from 'utils/styles';
import {aniQuestionInitial} from "../animations/question/initial";
// import QuestionResult from "../result/result";
const { classes } = createStyles(styles);



/* ========== ~~~~~~~~~~ ANSWER ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
class Answer extends Component {
    constructor(props) {
        super(props);
        // get the time a user sees the question (so when they answer we can see how long it took them, if they answer in only 1 second we know they aren't actually reading the content)
        // ***** this is will be a few milliseconds off since this component may mount 3 times, and there is a slight delay in the mounting (think if we have 3 questions) ***** //
        this.timer = new Timer();
        this.timer.start();
        this.resultWaitTime = new Timer();
        this.amountOfTimeBeforeAnswering = 0;
        this.resultTimeout = null;
        this.redeemTimeout = null;
        this.pointsAwardTimeout = null;
    }

    componentDidUpdate(prevProps) {
        // PROCESS RESULT / RECEIVED QUESTION RESPONSE RESULT
        if((prevProps.frameState === 'clicked' && this.props.frameState === 'result' ||
            this.props.isPreview && prevProps.frameState === 'initial' && this.props.frameState === 'result') && this.isSelected()) {
            this.handlePointsAward(this.props);
            this.handleResultPhase();
            this.props.showLoader(false);
            // ::: tracking: question answered ::: //
            this.trackQuestionAnswered(this.props);

        // PROCESS NETWORK ERROR
        } else if (prevProps.frameState === 'clicked' && this.props.frameState === 'networkError' && this.isSelected()) {
            this.props.showLoader(false);
            this.props.displayScreen({
                name: 'answerError',
                type: 'full',
                visible: true,
                content: <AnswerErrorScreen contentId={this.props.contentId} skipQuestion={this.handleSkipQuestion} />
            });

            // this.trackResponseError();
        }
    }
    isSelected = () => this.props.chosenAnswer === this.props.answer.id;

    isResult = () => this.props.frameState === 'result';

    isFactual = () => this.props.frameType === 'quiz';

    isCorrect = () => this.props.frameType === 'quiz' ? !!this.props.isCorrect : this.props.isCorrect;

    getFrameStatus = () => {
        if(this.props.frameState !== 'result') return '';
        return this.props.frameType !== 'quiz' ? 'answered' : !!this.props.isCorrect ? 'correct' : 'incorrect';
    };

    getQuestionStatus = () => this.props.frameState === 'result';

    displayAnswer = () => {
        switch (this.props.type) {
            case 'text1':
                return <Text1Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} isCorrectAnswer={this.isCorrect()} isClicked={this.isSelected()} isResult={this.isResult()} isQuestionAnswered={this.getQuestionStatus()} />;
            case 'text2':
                return <Text2Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} isCorrectAnswer={this.isCorrect()} isClicked={this.isSelected()} isResult={this.isResult()} />;
            case 'image1':
                return <Image1Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} image={this.props.answer.image} isCorrectAnswer={this.isCorrect()} isClicked={this.isSelected()} isResult={this.isResult()} isQuestionAnswered={this.getQuestionStatus()} />;
            case 'image2':
                return <Image2Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} image={this.props.answer.image} isCorrectAnswer={this.isCorrect()} isClicked={this.isSelected()} isResult={this.isResult()} isQuestionAnswered={this.getQuestionStatus()} />;
            case 'emoji':
                return <EmojiAnswer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} emoji={this.props.answer.emoji} isCorrectAnswer={this.isCorrect()} isClicked={this.isSelected()} isResult={this.isResult()} isQuestionAnswered={this.getQuestionStatus()} />;
            // case 'textbox':
            //     return <InputSet id={this.props.answer.id} text={this.props.answer.text} isClicked={this.isSelected()} isQuestionAnswered={this.getQuestionStatus()} />;
            default:
                return <Text2Answer id={this.props.answer.id} text={this.props.answer.text} predictionPercentage={this.props.predictionPercentage} barCoefficient={this.props.barCoefficient} isCorrectAnswer={this.isCorrect()} isClicked={this.isSelected()} isResult={this.isResult()} />;
        }
    };

    handleClick = () => {
        // In this component we set frame status.
        this.props.setAnswerClicked(this.props.contentId, this.props.frame, this.props.answer.id);
        this.props.showLoader(true);

        // Start wait time timer
        this.resultWaitTime.start();

        // refresh advertisements
        refreshAds(); // 7500 (this was previous value, a major delay so we did not interfere with the CSS animations running after answering a question)

        // >>> making BE request
        // if(window.parent.location.href.includes('mks.') && !window.parent.location.href.includes('v1')) { return null; }
        const isFactualQuestion = this.props.frameType === 'quiz';
        this.props.requestQuestionResponseResult(this.props.contentId, this.props.frame, isFactualQuestion, this.getQuestionResponseDetails(), this.props.isPubPortalPreview);
    };

    handleSkipQuestion = () => this.props.advanceFrame(this.props.contentId);

    handleResultPhase = () => {
        // const resultTimeFrame = this.props.showResultForXSeconds;
        // if (!resultTimeFrame) { return null; }
        // Setting an appropriate timeframe for the Result Phase
        this.resultTimeout = setTimeout(() => {
            // After the phase is over, move to check if the next (rewards) phase is enabled.
            clearTimeout(this.resultTimeout);
            this.props.advanceFrame(this.props.contentId);
         }, this.props.showResultForXSeconds);
    };

    getQuestionResponseDetails = () => ({
        cookieId: this.props.userId,
        embedUUID: this.props.embedUUID,
        contentUUID: this.props.question.id,
        contentSignature: this.props.questionSignature,
        contentType: this.isQuestionnaire() ? this.getQuestionnaireType() : this.props.frameType,
        pageUrl: window.parent.document.location.href,
        contentProperties: {
            questionText: this.props.question.text,
            optionText: this.props.answer.text,
            optionUUID: this.props.answer.id,
            answerSignature: this.props.answer.answerSignature
        }
    });

    isQuestionnaire = () => this.props.frameType === 'profile';

    getQuestionnaireType = () => this.isQuestionnaire() ? this.props.uniqueProps.questionnaireType.toLowerCase() : null;


    ///// =========== ~~~ =========== START: REWARDS LOGIC =========== ~~~ ===========/////
    getRewardPoints = (nextProps) => {
        if (!nextProps.validRequest) return 0; // Do't award any points if a question result request is not valid;
        const pointValues = this.props.frameType === 'profile' ? this.getPQPoints() : this.props.rewardsSettings.pointValues[this.props.frameType];
        return pointValues !== undefined && !(nextProps.frameType === 'quiz' && !nextProps.isCorrect) ? pointValues : 0;
    };
    getPQPoints = () => {
        const questionnaireType = this.props.uniqueProps.questionnaireType.toLowerCase();
        // return this.props.rewardsSettings.pointValues.profileQuestions[questionnaireType];
        // FALLBACK
        if (!!this.props.rewardsSettings.pointValues.profileQuestions && !!questionnaireType) {
            return this.props.rewardsSettings.pointValues.profileQuestions[questionnaireType];
        } else if (!!this.props.rewardsSettings.pointValues['profile']) {
            return this.props.rewardsSettings.pointValues['profile'];
        } else {
            return 0;
        }
    };

    handlePointsAward = (nextProps) => {
        const pointsEarnedAfterReward = this.props.rewardsStatus.pointsEarned - this.props.rewardsStatus.numberOfRewardsEarned * this.props.rewardsSettings.redeemAfter;
        const pointsEarnedForQuestion = this.getRewardPoints(nextProps);
        const currentPointsBalance = pointsEarnedAfterReward + pointsEarnedForQuestion;
        if (currentPointsBalance >= this.props.rewardsSettings.redeemAfter) {
            const rewardsEarned = Math.floor(currentPointsBalance / this.props.rewardsSettings.redeemAfter);
            // Delay points award to synchronize award with +1 badge animation
            this.pointsAwardTimeout = setTimeout(() => {
                this.props.awardPointsWithRewards(pointsEarnedForQuestion, rewardsEarned, true);
                clearTimeout(this.pointsAwardTimeout);
            }, 2100);
            // fire show screen action
            this.showRedeemScreen();
        } else {
            // Delay points award to synchronize award with +1 badge animation
            this.pointsAwardTimeout = setTimeout(() => {
                this.props.awardPoints(this.getRewardPoints(nextProps));
                clearTimeout(this.pointsAwardTimeout);
            }, 2100);
        }
    };

    showRedeemScreen = () => {
        const resultTimeFrame = this.props.showResultForXSeconds;
        if (!resultTimeFrame) {
            this.props.displayScreen({
                name: 'redeem',
                type: 'full',
                visible: true,
                content: <RedeemScreen contentId={this.props.contentId} />
            })
        } else {
            // Setting an appropriate timeframe for the Result Phase
            this.redeemTimeout = setTimeout(() => {
                // After the phase is over, move to check if the next (rewards) phase is enabled.
                clearTimeout(this.redeemTimeout);
                this.props.displayScreen({
                    name: 'redeem',
                    type: 'full',
                    visible: true,
                    content: <RedeemScreen contentId={this.props.contentId} />
                })
            }, this.props.showResultForXSeconds);
        }
    };

    ///// =========== ~~~ =========== END: REWARDS LOGIC =========== ~~~ ===========/////


    ////// --------------------------- START: TRACKING --------------------------- //////

    trackQuestionAnswered = nextProps => {
        const additionalProps = {
            amountOfTimeBeforeAnswering: this.timer.end(),
            resultWaitTime: this.resultWaitTime.end(),
            question: this.props.question,
            answer: this.props.answer,
            questionnaire: this.props.currentQuestionnaire ? this.props.currentQuestionnaire : null,
            validRequest: nextProps.validRequest,
            isCorrect: !!nextProps.isCorrect
        };
        trackEvent({ type: 'click', name: 'ceuContentEngaged', props: this.props, additionalProps });
    };

    // trackResponseError = () => {
    //     const additionalProps = {
    //         amountOfTimeBeforeAnswering: this.amountOfTimeBeforeAnswering,
    //         resultWaitTime: this.resultWaitTime.end(),
    //         question: this.props.question,
    //         answer: this.props.answer,
    //         questionnaire: this.props.currentQuestionnaire ? this.props.currentQuestionnaire : null
    //     };
    //     trackEvent('click', 'questionResultError', this.props, { ...additionalProps });
    // };

    ////// --------------------------- END: TRACKING --------------------------- //////


    render() {
        return(
            <li id={this.props.answer.id} className={`${classes.answer} ${this.props.type} selected-${this.isSelected()} factual-${this.isFactual()} ${this.getFrameStatus()} answer phase=${this.props.frameState}`} onClick={this.handleClick}>
                {this.displayAnswer()}
            </li>
        );
    }
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Answer;
